module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/food/burger-96876e2c2bc90b094cff19070fe9ac3e.svg";